//////////////////////////////////////////////////////   
//                                                  //   
//  PARA TODOS OS USUÁRIOS:                         //   
//                                                  //   
//  APARECE COMO BOTÃO DE                           //   
//  FILTRO NO HEADER DA PÁGINA HOME                 //   
//                                                  //   
//  FUNCIONALIDADE: ABRIR A ABA LATERAL             //   
//    ESQUERDA DOS FILTROS                          //    
//                                                  //   
//////////////////////////////////////////////////////   



//////////////////////////////////////////////////////////////////////////
//                                                                      //
//  LISTA DE PÁGINAS E OUTROS COMPONENTES QUE UTILIZAM ESSE ARQUIVO:    //
//                                                                      //
//      frontend/src/pages/home.js                                      //
//                                                                      //
//////////////////////////////////////////////////////////////////////////



import '../../assets/css/local/header.css';

function FiltroBotao() {
    return (  // SEMPRE RENDERIZA O BOTÃO
        <div className="w-2-rem mt-3 ml-5 header-top">
            <div className="header-size">
                <button className="carrinho-pqn-header my-1 w-100 montserrat" onClick={open_filtro}>
                    <i className="fa fa-filter"></i>
                </button>
            </div>
        </div>
    );
}


function open_filtro(){  // FUNÇÃO PARA APARECER A LATERAL ESQUERDA COM OPÇÕES DE FILTRO
    // FUNÇÃO CHAMADA NO CLICK DO BOTAO DE FILTRO DESSE COMPONENTE

    document.getElementById("filtro").classList.remove('d-none')
}

export default FiltroBotao;
  